import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header"]

  connect() {
    this.navbar = document.getElementById('main-navbar')
    this.header = this.headerTarget

    if (!this.navbar || !this.header) return

    this.updateHeaderPosition = this.updateHeaderPosition.bind(this)

    // Écouteurs d'événements pour les navigations Turbo
    document.addEventListener('turbo:load', this.updateHeaderPosition)
    document.addEventListener('turbo:render', this.updateHeaderPosition)

    // Appel initial avec un petit délai pour s'assurer que le DOM est prêt
    setTimeout(() => {
      this.updateHeaderPosition()
    }, 100)
  }

  disconnect() {
    document.removeEventListener('turbo:load', this.updateHeaderPosition)
    document.removeEventListener('turbo:render', this.updateHeaderPosition)
  }

  updateHeaderPosition() {
    // La navbar est toujours visible (plus de masquage automatique)
    // Header toujours positionné sous la navbar
    this.header.style.top = '4rem'
  }
}